var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Profile'),_c('p',{staticClass:"text-h4 text-sm-h3 ma-6"},[_vm._v("Experience")]),_c('Timeline')],1)}
var staticRenderFns = []

export { render, staticRenderFns }